// // src/app/modules/Visitors/main/VisitorsPage.jsx
// import React from "react";
// import { Route, Routes, useNavigate, useParams } from "react-router-dom";
// import { Visitors } from "./main"; // Your main Visitors component
// // import { VisitorDetailsModal } from "../../../../components/VisitorDetailsModal";

// export function VisitorsPage() {
//   const navigate = useNavigate();

//   return (
//     <>
//       {/* Main visitors page - always rendered */}
//       <Visitors />
      
//       {/* Nested routes - use relative paths (no leading /) */}
//       {/* <Routes>
//         <Route 
//           path="view/:id" 
//           element={<VisitorDetailsModalWrapper />} 
//         />
//       </Routes> */}
//     </>
//   );
// }

// function VisitorDetailsModalWrapper() {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   return null;
  
//   // return (
//   //   <VisitorDetailsModal
//   //     show={true}
//   //     profileId={id}
//   //     organizationId={null} // You'll need to get this from your state
//   //     onHide={() => navigate('/visitors')}
//   //   />
//   // );
// }




// src/app/modules/Members/MembersMainPage.jsx
import React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Visitors } from "./main";
import { VisitorDetails } from "./VisitorDetails";
import { shallowEqual, useSelector } from "react-redux";

export function VisitorsPage() {
  const navigate = useNavigate();
  
  const { org } = useSelector(
    (state) => ({
      org: state.auth.organization,
    }),
    shallowEqual
  );

  return (
    <Routes>
      {/* Main members list */}
      <Route path="/" element={<Visitors />} />
      
      {/* Member details page */}
      <Route 
        path="/view/:id" 
        element={<VisitorDetails organizationId={org?.organization_id} />} 
      />
    </Routes>
  );
}